module.exports = __webpack_public_path__ + "af0abb845a1a725f77ac6e4bba64a46b.svg";